import React, { Component } from 'react';
import { SEARCH_TABS, searchRoutes } from './models';
import { Page } from 'components/page-container';
import { PageHeader } from 'components/page-header';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import {
    applyFiltersAction,
    setFilter
} from 'actions/filters';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { IStore } from 'reducers/index';
import { isFeatureEnabled } from 'utilities/util';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
interface IMapStateToProps {
    featureToggles: IFeatureToggleModel[]
}
interface IMapDispatchToProps {
    setFilter: (name: string, value: string | boolean | any[] | number) => void;
    applyFilters: () => void;
}
interface IState {
    activeTab: number,
    shouldSubmit: boolean
}
interface IParam {
    triggerFetch: () => void;
    withoutFilters?: boolean;
    children?: React.ReactNode | React.ReactNodeArray;
}

export class _Search extends Component<IParam & RouteComponentProps & IMapDispatchToProps & IMapStateToProps, IState>{
    public tableRef: any = React.createRef();
    public myInput: any = React.createRef();
    public state = {
        activeTab: 1,
        shouldSubmit: false
    };
    constructor(props: any) {
        super(props);
    }
    public componentDidMount() {
        this.setCurrTab()
    }

    public componentDidUpdate(props: any, state: any) {
        if (this.props.location !== props.location) {
            this.setCurrTab();
        }
        if (this.state.activeTab !== state.activeTab) {
            if (this.props.location.search) {
                this.props.history.replace(this.props.location.pathname)
            }
        }
    }
    public setCurrTab = () => {
        let thisUrl = this.props.location.pathname;
        thisUrl = thisUrl.replace('/job-costing/search', '')
        let ids = 1;
        switch (thisUrl) {
            case '/booking':
                ids = 2
                break;
            case '/documents':
                ids = 3
                break;
            case '/cbl':
                ids = 4
                break;
            case '/equipment':
                ids = 5
                break;
            case '/ets':
                ids = 6
                break;
            case '/customer-invoices':
                ids = 7
                break;
            case '/exportJobs':
                ids = 8
                break;
        }
        if (this.myInput && this.myInput.current && this.myInput.current.value) {
            this.myInput.current.value = ''
        }
        this.setState({
            activeTab: ids
        })
    }
    public render() {
        return (
            <React.Fragment>
                <PageHeader>Job Costing</PageHeader>
                <Page>
                    {!this.props.withoutFilters && <div className="grid-wrapper align-text-right">
                        <div className="col-25 search-input">
                            <i className="fas fa-search" />
                            <input type="text" ref={this.myInput} onKeyUp={this.shouldSubmit} placeholder="Search" />
                        </div>
                    </div>}
                    {!this.props.withoutFilters && <TabComponent activeTab={this.state.activeTab - 1} name="search-filters" navLinks={SEARCH_TABS(false, isFeatureEnabled(FEATURE_TOGGLES.FINOPS_HBL_CONSUMPTION, this.props.featureToggles))} callbackFc={(e: number) => {
                        this.props.history.push(`/job-costing/search${searchRoutes(e)}`);
                    }
                    } />}
                    {this.props.children}
                </Page>
            </React.Fragment>
        );
    }
    private setFilter = (val: string) => {
        let target: string = '';
        const url = this.props.location.pathname.split('/')[3];
        switch (url) {
            case 'ets':
            case 'exportJobs':
            case 'documents':
                target = 'ReferenceNumbers';
                break;
            case 'equipment':
                target = 'equipmentNumber';
                break;
            case 'cbl':
                target = 'cblNumber';
                break;
            case 'booking':
                target = 'bookingNumber';
                break;
            case 'customer-invoices':
                target = 'internalInvoiceNumber';
                break;
            default:
                target = 'ReferenceNumber';
                break;
        }
        if (target && val) {
            this.props.setFilter(target, val);
        }
    }
    private shouldSubmit = (key: any) => {
        if (key.target && key.target.value) {
            this.setFilter(key.target.value);
            if (key.code === 13 || key.key === 'Enter') {
                this.props.applyFilters();
                this.props.triggerFetch()
            }
        }
    }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    setFilter: (name: string, value: string | boolean | any[] | number) => dispatch(setFilter(name, value)),
    applyFilters: () => dispatch(applyFiltersAction())
});
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    featureToggles: state.featureToggle.featureToggles
});
const __Search = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_Search);
export const Search = withRouter(__Search);